import React from 'react';
import { FaSearch, FaCoins, FaMicrochip } from 'react-icons/fa';
import AdsComponent from '../AdsComponent';

function Sidebar({
  searchTerm,
  handleSearchChange,
  hardwareTypes,
  handleHardwareTypeChange,
  filteredCurrencies,
  handleSelectCurrency,
  getCoinImage,
}) {
  return (
    <aside className="home-sidebar">
      <div className="sidebar-ad">
        <AdsComponent requiredSize="250x50" />
      </div>
      <h2>
        <FaCoins /> Coin Menu
      </h2>

      <div className="home-new-coins-link">
        <a href="/NewCoins">
          <FaCoins /> New Coins
        </a>
      </div>

      <div className="home-search-bar">
        <FaSearch />
        <input
          type="text"
          placeholder="Search by name or symbol"
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>

      <h3>
        <FaMicrochip /> Filter by Hardware
      </h3>
      <select onChange={handleHardwareTypeChange}>
        <option value="">Select hardware...</option>
        {hardwareTypes.map((type, index) => (
          <option key={index} value={type}>
            {type}
          </option>
        ))}
      </select>

      <div className="home-currency-list-container">
        <ul className="home-currency-list">
          {filteredCurrencies.map((currency) => (
            <li key={currency.symbol} className="home-currency-item">
              <img
                src={getCoinImage(currency.symbol)}
                onError={(e) => {
                  e.target.src = '/img/coins/DEFAULT.webp';
                }}
                alt={currency.name}
                onClick={() => handleSelectCurrency(currency.symbol)}
                style={{ cursor: 'pointer' }}
              />
              <span
                onClick={() => handleSelectCurrency(currency.symbol)}
                style={{ cursor: 'pointer' }}
              >
                {currency.symbol} - {currency.name}
              </span>

              {Array.isArray(currency.algo) && currency.algo.length > 1 && (
                <select
                  onChange={(e) => handleSelectCurrency(currency.symbol, e.target.value)}
                  className="algo-dropdown"
                  defaultValue=""
                >
                  <option value="" disabled>
                    Algorithm
                  </option>
                  {currency.algo.map((algo, index) => (
                    <option key={index} value={algo}>
                      {algo}
                    </option>
                  ))}
                </select>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div className="sidebar-ad">
        <AdsComponent requiredSize="300x250" />
      </div>
    </aside>
  );
}

export default Sidebar;
